import React from 'react'
import { mergeClasses } from '../../../utils/mergeClasses'

const Separator = React.forwardRef(
    (
        { className, orientation = 'horizontal', decorative = true, ...props },
        ref
    ) => {
        return (
            <div
                ref={ref}
                data-slot="separator"
                data-orientation={orientation}
                role={decorative ? 'none' : 'separator'}
                aria-orientation={!decorative ? orientation : undefined}
                className={mergeClasses(
                    'tw-shrink-0 tw-bg-border',
                    orientation === 'horizontal'
                        ? 'tw-h-px tw-w-full'
                        : 'tw-w-px tw-self-stretch',
                    className
                )}
                {...props}
            />
        )
    }
)
Separator.displayName = 'Separator'

export { Separator }
